module.exports = "/assets/data/4813c84ff94bdbb97718d96937da9be7-BN15.data.json";